(() => {
  const header = document.querySelector('.ss-site-header');
  if (!header) return;
  const menus = [...header.querySelectorAll('details')];
  const close = (menu, focus) => {
    menu.open = false;
    if (focus) menu.querySelector('summary').focus();
  };
  header.addEventListener('click', event => {
    const menu = event.target.closest('details');
    if (!menu) return;
    if (event.target.closest('.ss-phone-menu__close')) close(menu, true);
    else if (event.target.closest('a')) close(menu, false);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') menus.filter(menu => menu.open).forEach(menu => close(menu, true));
  });
  document.addEventListener('click', event => {
    if (!header.contains(event.target)) menus.forEach(menu => close(menu, false));
  });
})();
